package ui.location.detail

import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.staggeredgrid.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.graphics.*
import androidx.compose.ui.layout.*
import androidx.compose.ui.text.font.*
import androidx.compose.ui.unit.*
import api.*
import compose.assets.*
import compose.assets.svg.*
import org.jetbrains.compose.resources.*
import provider.*
import ssoft.frontend.generated.resources.*
import tools.*
import ui.resource.*
import ui.widget.*
import kotlin.math.*
import kotlin.time.Duration.Companion.milliseconds

@Composable
fun LocationScope.LocationBranding(
    nnvl: LocationScope.Wrapper,
    modifier: Modifier
) {
    Box(modifier) {
        LazyVerticalStaggeredGrid(
            columns = StaggeredGridCells.Adaptive(512.dp),
            modifier = Modifier.fillMaxSize(),
            contentPadding = PaddingValues(8.dp),
            verticalItemSpacing = 8.dp,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {

            item {
                Title(nnvl)
            }

            item {
                Header(nnvl)
            }
            item {
                Overlays(nnvl)
            }
            item {
                Texts(nnvl)
            }
            item {
                Colors(nnvl)
            }
            item {
                KioskSetup(nnvl)
            }
        }
    }
}


@Composable
private fun LocationScope.Colors(nnvl: LocationScope.Wrapper) {
    Surface(
        color = MaterialTheme.colorScheme.surfaceContainerLowest,
        tonalElevation = 2.dp,
        shadowElevation = 4.dp,
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(16.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Text(
                text = Res.string.location_detail__branding_color_background_label.rememberString(),
                style = MaterialTheme.typography.labelMedium
            )
            Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                ColorField(
                    field = nnvl.branding.background,
                    label = Res.string.location_detail__branding_color_background,
                    modifier =  Modifier.weight(1F)
                )
                ColorField(
                    field = nnvl.branding.onBackground,
                    label = Res.string.location_detail__branding_color_on_background,
                    modifier =  Modifier.weight(1F)
                )
            }
            Space(8.dp)
            Text(
                text = Res.string.location_detail__branding_color_primary_label.rememberString(),
                style = MaterialTheme.typography.labelMedium
            )
            Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                ColorField(
                    field = nnvl.branding.primary,
                    label = Res.string.location_detail__branding_color_primary,
                    modifier =  Modifier.weight(1F)
                )

                ColorField(
                    field = nnvl.branding.onPrimary,
                    label = Res.string.location_detail__branding_color_on_primary,
                    modifier =  Modifier.weight(1F)
                )
            }
            Space(8.dp)
            Text(
                text = Res.string.location_detail__branding_color_secondary_label.rememberString(),
                style = MaterialTheme.typography.labelMedium
            )
            Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                ColorField(
                    field = nnvl.branding.secondary,
                    label = Res.string.location_detail__branding_color_secondary,
                    modifier =  Modifier.weight(1F)
                )
                ColorField(
                    field = nnvl.branding.onSecondary,
                    label = Res.string.location_detail__branding_color_on_secondary,
                    modifier =  Modifier.weight(1F)
                )
            }

            Space(8.dp)
            Text(
                text = Res.string.location_detail__branding_color_primary_container_label.rememberString(),
                style = MaterialTheme.typography.labelMedium
            )
            Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                ColorField(
                    field = nnvl.branding.primaryContainer,
                    label = Res.string.location_detail__branding_color_primary_container,
                    modifier =  Modifier.weight(1F)
                )
                ColorField(
                    field = nnvl.branding.onPrimaryContainer,
                    label = Res.string.location_detail__branding_color_on_primary_container,
                    modifier =  Modifier.weight(1F)
                )
            }
            Space(8.dp)
            Text(
                text = Res.string.location_detail__branding_color_secondary_container_label.rememberString(),
                style = MaterialTheme.typography.labelMedium
            )
            Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                ColorField(
                    field = nnvl.branding.secondaryContainer,
                    label = Res.string.location_detail__branding_color_secondary_container,
                    modifier =  Modifier.weight(1F)
                )
                ColorField(
                    field = nnvl.branding.onSecondaryContainer,
                    label = Res.string.location_detail__branding_color_on_secondary_container,
                    modifier =  Modifier.weight(1F)
                )
            }
        }

    }
}


@Composable
private fun LocationScope.Texts(nnvl: LocationScope.Wrapper) {
    Surface(
        color = MaterialTheme.colorScheme.surfaceContainerLowest,
        tonalElevation = 2.dp,
        shadowElevation = 4.dp,
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(Modifier.fillMaxWidth().padding(16.dp)) {
            Text(
                text = Res.string.location_detail__branding_close_warn_label.rememberString(),
                style = MaterialTheme.typography.labelMedium
            )
            Space(8.dp)
            NameUI(
                name = nnvl.branding.closeWarningTitle,
                label = Res.string.location_detail__branding_close_warn_title_label
            )
            Space(24.dp)
            NameUI(
                name = nnvl.branding.closeWarningDesc,
                label = Res.string.location_detail__branding_close_warn_desc_label
            )
            Space(24.dp)
            NameUI(
                name = nnvl.branding.closeWarningAction,
                label = Res.string.location_detail__branding_close_warn_action_label
            )
        }
    }
}


@Composable
private fun LocationScope.KioskSetup(nnvl: LocationScope.Wrapper) {
    Surface(
        color = MaterialTheme.colorScheme.surfaceContainerLowest,
        tonalElevation = 2.dp,
        shadowElevation = 4.dp,
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(Modifier.fillMaxWidth().padding(16.dp)) {
            Text(
                text = Res.string.location_detail__branding_application_icon_scale_label.rememberString(),
                style = MaterialTheme.typography.labelMedium
            )
            Space(8.dp)
            Card {
                Row(Modifier.padding(horizontal = 16.dp)) {
                    Text(
                        text = "${nnvl.branding.dashboardIconScale.state} %",
                        modifier = Modifier.align(Alignment.CenterVertically),
                        fontWeight = FontWeight.Bold
                    )
                    Space(16.dp)
                    Slider(
                        value = nnvl.branding.dashboardIconScale.state / 100F,
                        valueRange = 0F..1F,
                        steps = 100,
                        onValueChange = { nnvl.branding.dashboardIconScale.set((it * 100F).roundToInt()) }
                    )
                }
            }

            Space(24.dp)

            Card(
                onClick = { nnvl.branding.dashboardSlideshowCrop.set(!nnvl.branding.dashboardSlideshowCrop.state) },
                modifier = Modifier.fillMaxWidth()
            ) {
                Row(Modifier.padding(horizontal = 16.dp)) {
                    IconicSwitch(
                        checked = nnvl.branding.dashboardSlideshowCrop.state,
                        modifier = Modifier.align(Alignment.CenterVertically),
                        onCheckedChange = {
                            nnvl.branding.dashboardSlideshowCrop.set(it)
                        }
                    )
                    Space(16.dp)
                    Text(
                        text = Res.string.location_detail__branding_photos_crop_enabled.rememberString(),
                        modifier = Modifier.align(Alignment.CenterVertically),
                        fontWeight = FontWeight.Bold
                    )
                }
            }

            Space(24.dp)

            Column {

                val selection = remember {
                    mutableStateOf(LocationScope.layoutVariants
                        .firstOrNull { it.type match nnvl.branding.dashboardLayout.state }
                        ?: LocationScope.layoutVariants.first())
                }

                Text(
                    text = Res.string.location_detail__branding_dashboard_layout_label.rememberString(),
                    style = MaterialTheme.typography.labelMedium
                )
                Space(8.dp)
                DropDownPickerCard(
                    selected = selection,
                    values = LocationScope.layoutVariants,
                    itemWidth = 256.dp,
                    useItemWidthForCardWidth = false,
                    modifier = Modifier.fillMaxWidth(),
                    onChange = { nnvl.branding.dashboardLayout.set(it.type.mask) }
                )
            }
        }
    }
}


@Composable
private fun LocationScope.Title(nnvl: LocationScope.Wrapper) {
    Surface(
        color = MaterialTheme.colorScheme.surfaceContainerLowest,
        tonalElevation = 2.dp,
        shadowElevation = 4.dp,
        modifier = Modifier.fillMaxWidth(),
        shape = TextFieldDefaults.shape
    ) {
        Box(
            modifier = Modifier.fillMaxWidth().padding(16.dp)
        ) {
            NameUI(nnvl.branding.name, Res.string.location_detail__branding_name)
        }
    }
}

@Composable
private fun LocationScope.Header(nnvl: LocationScope.Wrapper) {
    val display = LocalDisplayProvider.current
    Surface(
        color = MaterialTheme.colorScheme.surfaceContainerLowest,
        tonalElevation = 2.dp,
        shadowElevation = 4.dp,
        modifier = Modifier.fillMaxWidth()
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(16.dp),
            horizontalArrangement = Arrangement.spacedBy(24.dp)
        ) {
            LogoUI(
                companyId = nnvl.data.company.id,
                branding = nnvl.branding,
                modifier = Modifier
                    .align(Alignment.CenterVertically)
                    .size(
                        if (display.isMobile) 128.dp
                        else 256.dp
                    )
            )
            Column(verticalArrangement = Arrangement.spacedBy(24.dp)) {
                Timer(nnvl.branding.timeoutHandicap, Res.string.location_detail__branding_timeout_handicap)
                Timer(nnvl.branding.timeoutScreen, Res.string.location_detail__branding_timeout_screen)
                Timer(nnvl.branding.timeoutDialog, Res.string.location_detail__branding_timeout_dialog)
            }
        }
    }
}

@Composable
private fun LocationScope.Overlays(nnvl: LocationScope.Wrapper) {
    Surface(
        color = MaterialTheme.colorScheme.surfaceContainerLowest,
        tonalElevation = 2.dp,
        shadowElevation = 4.dp,
        modifier = Modifier.fillMaxWidth()
    ) {

        Column(Modifier.fillMaxWidth().padding(16.dp)) {
            Space(8.dp)
            Text(
                text = Res.string.location_detail__branding_overlay.rememberString(),
                style = MaterialTheme.typography.labelMedium
            )
            Space(8.dp)

            Row {
                Spacer(Modifier.weight(1F))
                OverlayPort(
                    companyId = nnvl.data.company.id,
                    branding = nnvl.branding,
                    modifier = Modifier.align(Alignment.CenterVertically)
                )
                Spacer(Modifier.weight(1F))
                OverlayLand(
                    companyId = nnvl.data.company.id,
                    branding = nnvl.branding,
                    modifier = Modifier.align(Alignment.CenterVertically)
                )
                Spacer(Modifier.weight(1F))
            }
        }
    }

}

@Composable
private fun LocationScope.Timer(field: EFieldRegularLong, title: StringResource) {
    val selection = remember(field) {
        val current = field.state.milliseconds
        mutableStateOf(LocationScope.timerVariants
            .firstOrNull { it.value == current }
            ?: LocationScope.timerVariants.first())
    }
    Column {
        Text(title.rememberString(), style = MaterialTheme.typography.labelMedium)
        Space(8.dp)
        DropDownPicker(
            selected = selection,
            values = LocationScope.timerVariants,
            itemWidth = 256.dp
        ) {
            field.set(it.value.inWholeMilliseconds)
        }
    }
}


@Composable
private fun NameUI(name: EFieldTextString, label: StringResource) {
    TextField(
        value = name.text,
        label = { Text(label.rememberString()) },
        leadingIcon = { Icon(Svg.Format_text, null) },
        isError = name.err,
        modifier = Modifier.fillMaxWidth(),
        onValueChange = { name.set(it) })
}


@Composable
private fun LocationScope.LogoUI(
    companyId: Long,
    branding: LocationScope.WrapperBranding,
    modifier: Modifier
) {
    ImagePicker(
        key = "LocationBranding:LogoUI:${args.locationId}",
        companyId = companyId,
        label = Res.string.location_detail__branding_logo,
        field = branding.logo,
        restrictionOrientation = ResourceOrientation.UNDEFINED,
        modifier = modifier
    )
}

@Composable
private fun LocationScope.OverlayLand(
    companyId: Long,
    branding: LocationScope.WrapperBranding,
    modifier: Modifier
) {
    Box(modifier) {
        ImagePicker(
            key = "LocationBranding:OverlayLand:${args.locationId}",
            companyId = companyId,
            label = Res.string.location_detail__branding_overlay_land,
            embeddedLabel = true,
            field = branding.overlayLand,
            restrictionOrientation = ResourceOrientation.HORIZONTAL,
            modifier = Modifier.width(320.dp)
                .aspectRatio(16F / 9F)
        )
    }
}

@Composable
private fun LocationScope.OverlayPort(
    companyId: Long,
    branding: LocationScope.WrapperBranding,
    modifier: Modifier
) {
    Box(modifier) {
        ImagePicker(
            key = "LocationBranding:OverlayPort:${args.locationId}",
            companyId = companyId,
            label = Res.string.location_detail__branding_overlay_port,
            embeddedLabel = true,
            field = branding.overlayPort,
            restrictionOrientation = ResourceOrientation.VERTICAL,
            modifier = Modifier.height(250.dp)
                .aspectRatio(9F / 16F)
        )
    }
}

@Composable
private fun LocationScope.ImagePicker(
    key: String,
    companyId: Long,
    label: StringResource,
    embeddedLabel: Boolean = false,
    field: EFieldRegularLong,
    restrictionOrientation: ResourceOrientation,
    modifier: Modifier = Modifier.size(256.dp)
) {
    GlobalObjectShare.Consumer(key)

    fun openResourcePicker() {
        GlobalObjectShare.launchImagePicker(
            key = key,
            nav = nav,
            args = ResourceListingArgs(
                companyId = companyId,
                restrictionType = ResourceType.IMAGE.mask,
                restrictionOrientation = restrictionOrientation.mask
            )
        ) {
            it.firstOrNull()?.apply {
                field.set(id)
            }
        }
    }

    Column {
        if (embeddedLabel) {
            Card({ openResourcePicker() }) {
                Box(modifier) {
                    LazyImage(
                        id = field.state,
                        contentScale = ContentScale.Fit,
                        modifier = Modifier.fillMaxSize()
                    )
                    Text(
                        label.rememberString(),
                        style = MaterialTheme.typography.labelMedium,
                        modifier = Modifier
                            .fillMaxWidth()
                            .align(Alignment.BottomEnd)
                            .background(Color.Black.copy(0.4F))
                            .padding(8.dp)
                    )
                }
            }
        } else {
            Text(label.rememberString(), style = MaterialTheme.typography.labelMedium)
            Space(8.dp)
            Card({ openResourcePicker() }) {
                LazyImage(
                    id = field.state,
                    contentScale = ContentScale.Fit,
                    modifier = modifier
                )
            }
        }
    }
}
